import { Text, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';

interface GaragingAddressCardProps {
  data?: any;
}

const GaragingAddressCard = ({ data }: GaragingAddressCardProps) => {
  const colors = useBinderCardColors();
  const vehicles = data?.vehicles || [];
  const applicationAddress = data?.applicationAddress || '';

  // Format the table rows for each vehicle
  const headers = ['Vehicle', 'Garaging Address', 'Remarks'];
  const rows = vehicles.map((vehicle: any) => [
    vehicle.vehicleName,
    vehicle.garagingAddress,
    vehicle.remarks || (
      <Text color="gray.400" fontStyle="italic" fontSize="sm">
        No remarks
      </Text>
    ),
  ]);

  return (
    <>
      {/* Show applicant address for reference */}
      <Box mb={4} p={3} bg={colors.emptyFieldBgColor} borderRadius="md">
        <Text fontSize="sm" fontWeight="medium" color={colors.labelColor}>
          Applicant Address:
        </Text>
        <Text fontSize="sm" mt={1}>
          {applicationAddress || 'Not specified'}
        </Text>
      </Box>

      {/* Vehicles table */}
      <DataTableCard
        description="Verify that all vehicles are garaged at the applicant's address."
        headers={headers}
        rows={rows}
      />
    </>
  );
};

export default GaragingAddressCard;
